module.exports = __webpack_public_path__ + "static/media/2.25e36648.jpg";